import React, { useState } from 'react'
import { connect } from 'react-redux'
import { Row, Col, Form, Input, Button, Typography, message } from 'antd'
import { ROW_JUSTIFY, COL_SPAN } from '../common/const'
import API from '../config/api'
import { PostTeamJoin, PostUserAdd } from '../config/request'
import { useIntl } from 'react-intl'
import errCode, { GetErrMsg } from '../config/errCode'
import {
  OpenBrowserUrl,
  getRedirectUrl,
  CheckSystem,
} from '../common/globalFun'

import HeaderLogo from '../components/HeaderLogo'
import PageBg from '../components/PageBg'
import PageHeaderComponents from '../components/PageHeader'

import './css/style.css'

const md5 = require('js-md5')
const { Title } = Typography

const CreateAccountPage = (props) => {
  const { history } = props
  const intl = useIntl()
  const validateMessages = {
    required: '',
  }

  const [loading, setLoading] = useState(false)

  const submit = (values) => {
    const { name } = values
    addUserInfo(name)
  }

  const addUserInfo = (account) => {
    setLoading(true)
    props.setGlobalAccount(account)

    PostUserAdd({
      account: props.email,
      userName: account,
    })
      .then(() => {
        if (props.inviteCode) {
          autoJoinOrg(account, props.inviteCode)
        } else {
          history.push({
            pathname: '/signin_org',
            data: { comeBackDisabled: true },
          })
        }
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const autoJoinOrg = (account, invite_code) => {
    setLoading(true)

    PostTeamJoin({
      account: account,
      invite_code: invite_code,
    })
      .then((rsp) => {
        if (CheckSystem.Felo()) {
          const { loginKey, login_key } = rsp
          props.setGlobalLoginKey(loginKey || login_key)
          history.push('/download')
        } else {
          OpenBrowserUrl(getRedirectUrl())
        }
      })
      .catch((err) => {
        if (err && err.errCode == 'A038') {
          history.push({ pathname: '/signin_org', data: { name: account } })
        }
      })
      .finally(() => {
        setLoading(false)
      })
  }

  return (
    <>
      <PageHeaderComponents className="page-header" title=" " />
      <PageBg />
      <Row
        justify={ROW_JUSTIFY}
        align="middle"
        className={`height-full create-account-page`}
      >
        <Col span={COL_SPAN}>
          <section className={`hd-section createTeamHead`}>
            <HeaderLogo />
            <Title level={2}>
              {intl.formatMessage({ id: 'create.account.title' })}
            </Title>
          </section>
          <div className="mt-30 mb-30">
            <Title level={5}>
              {intl.formatMessage(
                { id: 'get.started.title' },
                { email: props.email }
              )}
            </Title>
          </div>

          <Form
            validateMessages={validateMessages}
            onFinish={submit}
            layout="vertical"
          >
            <Form.Item
              label={intl.formatMessage({ id: 'full.name' })}
              name="name"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input
                autoFocus
                placeholder={intl.formatMessage({ id: 'enter.name' })}
                size="large"
              />
            </Form.Item>
            {/* <Form.Item name="password" label="Password" rules={[
                        {
                            required: true,
                        }
                    ]}>
                        <Input.Password placeholder="Enter your password" size="large" />
                    </Form.Item> */}
            <Form.Item>
              <Button
                block
                className="mt-20"
                loading={loading}
                size="large"
                type="primary"
                htmlType="submit"
              >
                {intl.formatMessage({ id: 'create.account' })}
              </Button>
            </Form.Item>
            <p className="content-center">
              {intl.formatMessage({ id: 'agree.privacy' })}
            </p>
          </Form>
        </Col>
      </Row>
    </>
  )
}

const stateProps = (state) => {
  return {
    account: state.account,
    token: state.token,
    email: state.email,
    inviteCode: state.inviteCode,
  }
}

const dispatchProps = (dispatch) => ({
  setGlobalLoginKey: (key) => {
    dispatch({
      type: 'setLoginKey',
      value: key,
    })
  },
  setGlobalAccount: (account) => {
    dispatch({
      type: 'setAccount',
      value: account,
    })
  },
})

export default connect(stateProps, dispatchProps)(CreateAccountPage)
